export const onRefresh = () => {
  window.location.reload();
};
